import { http } from '@/api/http';

export interface SystemBuildInfoBuildBlockDto {
  readonly version: string | null;
  readonly time: string | null;
}

export interface SystemBuildInfoGitBlockDto {
  readonly commit_id: string | null;
  readonly commit_id_abbrev: string | null;
  readonly branch: string | null;
  readonly dirty: string | null;
}

export interface SystemBuildInfoInstanceDto {
  readonly instance_id: string | null;
  readonly host: string | null;
  readonly port: number;
  readonly secure: boolean;
  readonly status: string | null;
  readonly build: SystemBuildInfoBuildBlockDto;
  readonly git: SystemBuildInfoGitBlockDto;
}

export interface SystemBuildInfoServiceDto {
  readonly service_id: string;
  readonly instances: readonly SystemBuildInfoInstanceDto[];
}

export interface SystemBuildInfoDto {
  readonly services: readonly SystemBuildInfoServiceDto[];
  readonly aggregated_at: string;
}

export const adminBuildInfoEndpoints = {
  /**
   * GET /system/build-info — admin-only cluster build inventory.
   *
   * Endpoint is admin-gated (mirrors `/discover/**`); a non-admin caller gets a 403 envelope
   * from the BFF. Local types until the ai-hub OpenAPI contract is updated; the snake_case
   * shape mirrors the backend DTO at
   * `libs/commons-lib/.../dto/system/response/SystemBuildInfoDTO.java`.
   */
  getSystemBuildInfo: (options?: { signal?: AbortSignal }): Promise<SystemBuildInfoDto> =>
    http.get<SystemBuildInfoDto>('/system/build-info', options),
};
